module.exports = __webpack_public_path__ + "img/Logo-6.29f56a41.svg";